import {Vue} from 'ui.vue';

export let StockList = {
	name: 'StockList',
	data: function () {
		return {
			list: [],
			pagination: {},
			loading: false,
			load: {
				start: false,
				pageNumber: 1,
				isMoreLink: false
			},
			restParams: {
				key: "",
				nav: [],
			},
		};
	},
	computed: {
		loc() {
			return Vue.getFilteredPhrases("STOCK_BNL_");
		}
	},
	methods: {
		detailPageUrl(url) {
			return null === url || !url ? 'javascript:void(0)' : url;
		},
		onChangePage(data) {
			this.load = {
				start: true,
				pageNumber: data.hasOwnProperty('pageNumber') ? data['pageNumber'] : 1,
				isMoreLink: data.hasOwnProperty('isMoreLink') ? data['isMoreLink'] : false,
			};

			if (this.loading || !this.pagination) {
				return false;
			}

			this.loading = true;

			this.restParams['nav'] = {
				param: this.pagination.pageParam,
				value: this.load.pageNumber
			};

			BX.rest.callMethod("citrus.component.execute", this.restParams,
				(response) => {
					this.loading = false;

					if (response.answer.hasOwnProperty("error")) {
						console.info(response);
						return;
					}

					let result = response.answer.result;
					if (this.load.isMoreLink) {
						this.list = this.list.concat(result.product);
					} else {
						this.list = result.product;
					}

					this.load.start = false;
					BX.onCustomEvent('Citrus.Component.Element.List:ajaxLoadDataCompleted', [result.product]);
				}
			);
		},
	},
};

export default {StockList};
